import { axios } from '../api/axios';

export function useAxios() {
  return { axios };
}
